bovoApp.controller('AllocationController', ['$scope', 'Allocation', '$location', '$routeParams', '$filter', '$translate', 'FileUploader','$rootScope', '$q',
  function ($scope, Allocation, $location, $routeParams, $filter, $translate, FileUploader,$rootScope, $q) {
    $scope.deleted = [];
    $scope.allocationTabType = 'main';

    $scope.all = function () {
      Allocation.all().success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.setTab = function (val) {
      $scope.allocationTabType = val;

      // Load data when switching to specific tabs
      if (val === 'suggestions') {
        $scope.loadSuggestions();
      } else if (val === 'rules') {
        $scope.loadRules();
      } else if (val === 'blacklist') {
        $scope.loadCitiesDistricts();
        $scope.loadBlacklist();
      }
    }

    $scope.openDetail = function (item) {
      $scope.allocationTabType = 'main';
      Allocation.get(item.id).success(function (data, status, headers, config) {
        $('#allocationModal').modal('show');
        $scope.allocation = data.allocation;
        $scope.formData = data;
        $scope.suggestions = data.allocation.suggestions || [];
        $scope.rules = data.allocation.rules || [];
        $scope.blacklist = data.allocation.blacklists || [];
        $scope.selectedSuggestions = [];

        // Firma listesi - dropdown için (ui-grid format)
        $scope.companyList = [
          { id: '', company: '' },
          { id: 'HEPSIJET', company: 'HEPSIJET' },
          { id: 'SENDEO', company: 'SENDEO' },
          { id: 'MNG', company: 'MNG' },
          { id: 'PTT', company: 'PTT' },
          { id: 'YURTICI', company: 'YURTICI' },
          { id: 'ARAS', company: 'ARAS' },
          { id: 'UPS', company: 'UPS' },
          { id: 'FEDEX', company: 'FEDEX' },
          { id: 'DPD', company: 'DPD' },
          { id: 'GLS', company: 'GLS' },
          { id: 'WIDECT', company: 'WIDECT' },
          { id: 'BOLT', company: 'BOLT' },
          { id: 'BOVOBOLT', company: 'BOVOBOLT' },
          { id: 'BOVO', company: 'BOVO' },
          { id: 'KARGOIST', company: 'KARGOIST' },
          { id: 'MARS', company: 'MARS' },
          { id: 'TAKOLOG', company: 'TAKOLOG' },
          { id: 'GKN', company: 'GKN' },
          { id: 'SURAT', company: 'SURAT' },
          { id: 'KOLAYGELSIN', company: 'KOLAYGELSIN' },
          { id: 'ANKARAKARGO', company: 'ANKARAKARGO' },
          { id: 'YANGO', company: 'YANGO' },
          { id: 'SCOTTY', company: 'SCOTTY' },
          { id: 'TRENDYOL', company: 'TRENDYOL' },
          { id: 'KARGOM', company: 'KARGOM' },
          { id: 'GELAL', company: 'GELAL' },
          { id: 'HERO', company: 'HERO' },
          { id: 'KARGOTURK', company: 'KARGOTURK' },
          { id: 'PAZARAMA', company: 'PAZARAMA' },
          { id: 'SHIPMENTHUB', company: 'SHIPMENTHUB' },
          { id: 'AMAZON', company: 'AMAZON' },
          { id: 'DHL', company: 'DHL' },
          { id: 'AVES', company: 'AVES' },
          { id: 'BIRGUNDE', company: 'BIRGUNDE' },
        ];

        $rootScope.gridOptionsComplex = {
					enableFiltering: true,
					showGridFooter: true,
					showColumnFooter: true,
					paginationPageSizes: [500, 1000, 2000],
					paginationPageSize: 500,
					enableGridMenu: true,
					exporterCsvFilename: 'KararListesi.csv',
					exporterPdfDefaultStyle: { fontSize: 9 },
					exporterPdfTableStyle: { margin: [30, 30, 30, 30] },
					exporterPdfTableHeaderStyle: { fontSize: 10, bold: true, italics: true, color: 'red' },
					exporterPdfHeader: { text: "My Header", style: 'headerStyle' },
					exporterPdfFooter: function (currentPage, pageCount) {
						return { text: currentPage.toString() + ' of ' + pageCount.toString(), style: 'footerStyle' };
					},
					exporterPdfCustomFormatter: function (docDefinition) {
						docDefinition.styles.headerStyle = { fontSize: 22, bold: true };
						docDefinition.styles.footerStyle = { fontSize: 10, bold: true };
						return docDefinition;
					},
					exporterPdfOrientation: 'portrait',
					exporterPdfPageSize: 'LETTER',
					exporterPdfMaxGridWidth: 500,
					exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
					exporterExcelFilename: 'Fatura.xlsx',
					exporterExcelSheetName: 'Sheet1',
					exporterExcelCustomFormatters: function (grid, workbook, docDefinition) {
						var stylesheet = workbook.getStyleSheet();
						var stdStyle = stylesheet.createFontStyle({
							size: 9, fontName: 'Calibri'
						});
						var boldStyle = stylesheet.createFontStyle({
							size: 9, fontName: 'Calibri', bold: true
						});
						var aFormatDefn = {
							"font": boldStyle.id,
							"alignment": { "wrapText": true }
						};
						var formatter = stylesheet.createFormat(aFormatDefn);
						$scope.formatters['bold'] = formatter;
						var dateFormatter = stylesheet.createSimpleFormatter('date');
						$scope.formatters['date'] = dateFormatter;
						aFormatDefn = {
							"font": stdStyle.id,
							"fill": { "type": "pattern", "patternType": "solid", "fgColor": "FFFFC7CE" },
							"alignment": { "wrapText": true }
						};
						var singleDefn = {
							font: stdStyle.id,
							format: '#,##0.0'
						};
						formatter = stylesheet.createFormat(aFormatDefn);
						$scope.formatters['red'] = formatter;
						Object.assign(docDefinition.styles, $scope.formatters);
						return docDefinition;
					},
					exporterColumnScaleFactor: 4.5,
					exporterFieldApplyFilters: true,
					columnDefs: [
						{ name: 'İl', field: 'city', enableCellEdit: false, minWidth: 80, width: '*' },
						{ name: 'İlçe', field: 'district', enableCellEdit: false, minWidth: 90, width: '*' },
						{
							name: 'Min Desi', field: 'min_weight', enableCellEdit: false, minWidth: 60, width: 70
						},
						{
							name: 'Max Desi', field: 'max_weight', enableCellEdit: false, minWidth: 60, width: 70
						},
						{
							name: 'Firma 1',
							field: 'company_1',
							editableCellTemplate: 'ui-grid/dropdownEditor',
							editDropdownOptionsArray: $scope.companyList || [],
							editDropdownIdLabel: 'id',
							editDropdownValueLabel: 'company',
							minWidth: 100, width: '*'
						},
						{ name: 'Kap.1', field: 'company_1_capacity', type: 'number', enableCellEdit: true, minWidth: 55, width: 65 },
						{
							name: 'Firma 2',
							field: 'company_2',
							editableCellTemplate: 'ui-grid/dropdownEditor',
							editDropdownOptionsArray: $scope.companyList || [],
							editDropdownIdLabel: 'id',
							editDropdownValueLabel: 'company',
							minWidth: 100, width: '*'
						},
						{ name: 'Kap.2', field: 'company_2_capacity', type: 'number', enableCellEdit: true, minWidth: 55, width: 65 },
						{
							name: 'Firma 3',
							field: 'company_3',
							editableCellTemplate: 'ui-grid/dropdownEditor',
							editDropdownOptionsArray: $scope.companyList || [],
							editDropdownIdLabel: 'id',
							editDropdownValueLabel: 'company',
							minWidth: 100, width: '*'
						},
						{ name: 'Kap.3', field: 'company_3_capacity', type: 'number', enableCellEdit: true, minWidth: 55, width: 65 }
					],
					data: data.allocation.rows
				};
        $rootScope.gridOptionsComplex.onRegisterApi = function (gridApi) {
					$scope.gridApi = gridApi;

          // Satır düzenlendiğinde değişiklikleri takip et
          gridApi.rowEdit.on.saveRow($scope, function (rowEntity) {
            var promise = $q.defer();
            // Otomatik kaydetme yerine kullanıcı manuel kaydetsin (performans için)
            promise.resolve();
            return promise.promise;
          });
				};

        // Quota
        if(!data.allocation.quota) {
          data.allocation.quota = {
            rows: []
          }
        }
        $rootScope.gridOptionsComplexQuota = {
					enableFiltering: true,
					showGridFooter: true,
					showColumnFooter: true,
					paginationPageSizes: [500, 1000, 2000],
					paginationPageSize: 500,
					enableGridMenu: true,
					enableSelectAll: true,
					exporterCsvFilename: 'KararKotaListesi.csv',
					exporterPdfDefaultStyle: { fontSize: 9 },
					exporterPdfTableStyle: { margin: [30, 30, 30, 30] },
					exporterPdfTableHeaderStyle: { fontSize: 10, bold: true, italics: true, color: 'red' },
					exporterPdfHeader: { text: "My Header", style: 'headerStyle' },
					exporterPdfFooter: function (currentPage, pageCount) {
						return { text: currentPage.toString() + ' of ' + pageCount.toString(), style: 'footerStyle' };
					},
					exporterPdfCustomFormatter: function (docDefinition) {
						docDefinition.styles.headerStyle = { fontSize: 22, bold: true };
						docDefinition.styles.footerStyle = { fontSize: 10, bold: true };
						return docDefinition;
					},
					exporterPdfOrientation: 'portrait',
					exporterPdfPageSize: 'LETTER',
					exporterPdfMaxGridWidth: 500,
					exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
					exporterExcelFilename: 'Fatura.xlsx',
					exporterExcelSheetName: 'Sheet1',
					exporterExcelCustomFormatters: function (grid, workbook, docDefinition) {
						var stylesheet = workbook.getStyleSheet();
						var stdStyle = stylesheet.createFontStyle({
							size: 9, fontName: 'Calibri'
						});
						var boldStyle = stylesheet.createFontStyle({
							size: 9, fontName: 'Calibri', bold: true
						});
						var aFormatDefn = {
							"font": boldStyle.id,
							"alignment": { "wrapText": true }
						};
						var formatter = stylesheet.createFormat(aFormatDefn);
						$scope.formatters['bold'] = formatter;
						var dateFormatter = stylesheet.createSimpleFormatter('date');
						$scope.formatters['date'] = dateFormatter;
						aFormatDefn = {
							"font": stdStyle.id,
							"fill": { "type": "pattern", "patternType": "solid", "fgColor": "FFFFC7CE" },
							"alignment": { "wrapText": true }
						};
						var singleDefn = {
							font: stdStyle.id,
							format: '#,##0.0'
						};
						formatter = stylesheet.createFormat(aFormatDefn);
						$scope.formatters['red'] = formatter;
						Object.assign(docDefinition.styles, $scope.formatters);
						return docDefinition;
					},
					exporterColumnScaleFactor: 4.5,
					exporterFieldApplyFilters: true,
					columnDefs: [
						{ name: 'İl', field: 'city' },
						{ name: 'İlçe', field: 'district' },
						{
							name: 'Firma 1', field: 'company_1'
						},
						{ name: 'Kapasite 1', field: 'company_1_capacity', type: 'number' },
						{
							name: 'Firma 2', field: 'company_2'
						},
						{ name: 'Kapasite 2', field: 'company_2_capacity', type: 'number' },
						{
							name: 'Firma 3', field: 'company_3'
						},
						{ name: 'Kapasite 3', field: 'company_3_capacity', type: 'number' },
					],
					data: data.allocation.quota.rows
				};
        $rootScope.gridOptionsComplexQuota.onRegisterApi = function (gridApi) {
					$scope.gridApi = gridApi;
				};
      });
    }

    $scope.$on('new_data', function () {
      $('#allocationModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Allocation.new().success(function (data, status, headers, config) {
        $scope.formData = data;
        $scope.allocation = {
          name: 'ALLOKASYON-TABLO-',
          status: 'active',
          file: null
        };
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Allocation.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate('Silindi'));
          $scope.all();
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function () {
      if ($scope.allocation.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.postQuotaForm = function () {
      Allocation.saveQuota($scope.allocation).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#allocationModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.save = function () {
      Allocation.save($scope.allocation).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#allocationModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      Allocation.update($scope.allocation).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#allocationModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    $scope.addPrice = function (workType, type) {
      $scope.allocation.prices.push({
        min_weight: null,
        type: 'weight',
        work_type: workType,
        price_type: type
      });
    }

    $scope.removePrice = function (item) {
      var index = $scope.allocation.prices.findIndex(function (elm) {
        return elm.$$hashKey == item.$$hashKey
      })
      $scope.allocation.prices.splice(index, 1);
    }

    var file = $scope.file = new FileUploader({
      url: '/api/upload-allocation',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      autoUpload: true
    });

    file.filters.push({
      name: 'formatFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|xlsx|xls|vnd.openxmlformats-officedocument.spreadsheetml.sheet|vnd.ms-excel|'.indexOf(type) !== -1;
      }
    });

    file.onAfterAddingFile = function (fileItem) {
      $scope.proccessProfile = true;
      $scope.pending = true;
    };

    file.onCompleteItem = function (item, response, status, headers) {
      $scope.proccessProfile = false;
      $scope.allocation.file = response.file;
      if (response.status == 'success')
        $scope.pending = false;
    }

    // Ouota
    var quotaFile = $scope.quotaFile = new FileUploader({
      url: '/api/upload-allocation',
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
      autoUpload: true
    });

    quotaFile.filters.push({
      name: 'formatFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|xlsx|xls|vnd.openxmlformats-officedocument.spreadsheetml.sheet|vnd.ms-excel|'.indexOf(type) !== -1;
      }
    });

    quotaFile.onAfterAddingFile = function (fileItem) {
      $scope.proccessProfile = true;
      $scope.pending = true;
    };

    quotaFile.onCompleteItem = function (item, response, status, headers) {
      $scope.proccessProfile = false;
      $scope.allocation.quota.file = response.file;
      if (response.status == 'success') {
        $scope.pending = false;
      }
    }

    // ============ SUGGESTIONS ============
    // Filtre ve sıralama ayarları
    $scope.suggestionFilter = {
      ruleType: '', // '', price, on_time, lost_rate, return_rate, open_delayed, customer_blacklist
      action: '', // '', replace, remove, warning
      city: '',
      district: '',
      currentCompany: '',
      suggestedCompany: '',
      sortBy: 'savings', // savings, price_diff, city, volume, current_price, suggested_price
      sortOrder: 'desc' // desc, asc
    };

    $scope.loadSuggestions = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      Allocation.getSuggestions($scope.allocation.id).success(function (data) {
        $scope.suggestions = data.suggestions;
        $scope.suggestionsSummary = data.summary || {};
        $scope.selectedSuggestions = [];
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Öneriler yüklenemedi',
          type: 'error'
        });
      });
    };

    // Filtre için unique değerleri al
    $scope.getFilterValues = function () {
      if (!$scope.suggestions) return { cities: [], districts: [], currentCompanies: [], suggestedCompanies: [] };

      var cities = {};
      var districts = {};
      var currentCompanies = {};
      var suggestedCompanies = {};

      $scope.suggestions.forEach(function (s) {
        if (s.status === 'pending') {
          if (s.city) cities[s.city] = true;
          if (s.district) districts[s.district] = true;
          if (s.current_company) currentCompanies[s.current_company] = true;
          if (s.suggested_company) suggestedCompanies[s.suggested_company] = true;
        }
      });

      return {
        cities: Object.keys(cities).sort(),
        districts: Object.keys(districts).sort(),
        currentCompanies: Object.keys(currentCompanies).sort(),
        suggestedCompanies: Object.keys(suggestedCompanies).sort()
      };
    };

    // Önerileri filtrele ve sırala
    $scope.getFilteredSuggestions = function () {
      if (!$scope.suggestions) return [];

      var f = $scope.suggestionFilter;

      var filtered = $scope.suggestions.filter(function (s) {
        // Sadece pending öneriler
        if (s.status !== 'pending') return false;

        // İl filtresi (exact match)
        if (f.city && s.city !== f.city) {
          return false;
        }

        // İlçe filtresi (exact match)
        if (f.district && s.district !== f.district) {
          return false;
        }

        // Mevcut firma filtresi (exact match)
        if (f.currentCompany && s.current_company !== f.currentCompany) {
          return false;
        }

        // Önerilen firma filtresi (exact match)
        if (f.suggestedCompany && s.suggested_company !== f.suggestedCompany) {
          return false;
        }

        // Rule type filtresi
        if (f.ruleType && s.rule_type !== f.ruleType) {
          return false;
        }

        // Action filtresi
        if (f.action && s.action !== f.action) {
          return false;
        }

        return true;
      });

      // Sırala
      filtered.sort(function (a, b) {
        var valA, valB;

        switch ($scope.suggestionFilter.sortBy) {
          case 'savings':
            valA = a.savings_amount || 0;
            valB = b.savings_amount || 0;
            break;
          case 'price_diff':
            valA = (a.current_price || 0) - (a.suggested_price || 0);
            valB = (b.current_price || 0) - (b.suggested_price || 0);
            break;
          case 'city':
            valA = a.city || '';
            valB = b.city || '';
            break;
          case 'volume':
            valA = a.monthly_volume || 0;
            valB = b.monthly_volume || 0;
            break;
          case 'current_price':
            valA = a.current_price || 0;
            valB = b.current_price || 0;
            break;
          case 'suggested_price':
            valA = a.suggested_price || 0;
            valB = b.suggested_price || 0;
            break;
          default:
            valA = a.savings_amount || 0;
            valB = b.savings_amount || 0;
        }

        if ($scope.suggestionFilter.sortOrder === 'asc') {
          return valA > valB ? 1 : (valA < valB ? -1 : 0);
        } else {
          return valA < valB ? 1 : (valA > valB ? -1 : 0);
        }
      });

      return filtered;
    };

    // Rule type label'ı al
    $scope.getRuleTypeFilterLabel = function (ruleType) {
      return {
        'all': 'Tüm Öneriler',
        'price': 'Fiyat Optimizasyonu',
        'on_time': 'Zamanında Teslimat',
        'lost_rate': 'Kayıp Oranı',
        'return_rate': 'İade Oranı',
        'open_delayed': 'Açık/Geciken',
        'customer_blacklist': 'Müşteri Talebi'
      }[ruleType] || ruleType;
    };

    // Action label'ı al
    $scope.getActionFilterLabel = function (action) {
      return {
        'all': 'Tüm İşlemler',
        'replace': 'Değiştir',
        'remove': 'Kaldır',
        'warning': 'Uyarı'
      }[action] || action;
    };

    // Sıralama label'ı al
    $scope.getSortLabel = function (sortBy) {
      return {
        'savings': 'Tasarruf Tutarı',
        'price_diff': 'Birim Fiyat Farkı',
        'city': 'İl',
        'volume': 'Hacim',
        'current_price': 'Eski Fiyat',
        'suggested_price': 'Yeni Fiyat'
      }[sortBy] || sortBy;
    };

    // Tüm filtreleri temizle
    $scope.clearAllFilters = function () {
      $scope.suggestionFilter.city = '';
      $scope.suggestionFilter.district = '';
      $scope.suggestionFilter.currentCompany = '';
      $scope.suggestionFilter.suggestedCompany = '';
      $scope.suggestionFilter.ruleType = '';
      $scope.suggestionFilter.action = '';
    };

    // Filtre değiştiğinde sıralama yönünü değiştir
    $scope.toggleSortOrder = function (sortBy) {
      if ($scope.suggestionFilter.sortBy === sortBy) {
        $scope.suggestionFilter.sortOrder = $scope.suggestionFilter.sortOrder === 'desc' ? 'asc' : 'desc';
      } else {
        $scope.suggestionFilter.sortBy = sortBy;
        $scope.suggestionFilter.sortOrder = 'desc';
      }
    };

    $scope.generateSuggestions = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      $scope.generatingSuggestions = true;
      Allocation.generateSuggestions($scope.allocation.id).success(function (data) {
        $scope.generatingSuggestions = false;
        Messenger().post('Öneriler oluşturuldu: ' + data.suggestion_count + ' adet');
        $scope.loadSuggestions();
      }).error(function (data) {
        $scope.generatingSuggestions = false;
        Messenger().post({
          message: data.message || 'Öneriler oluşturulamadı',
          type: 'error'
        });
      });
    };

    $scope.applySuggestion = function (suggestion) {
      if (!confirm('Bu öneriyi uygulamak istediğinize emin misiniz?')) return;

      Allocation.applySuggestion({ id: suggestion.id }).success(function (data) {
        Messenger().post('Öneri uygulandı');
        $scope.loadSuggestions();
        $scope.openDetail($scope.allocation); // Reload allocation
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Öneri uygulanamadı',
          type: 'error'
        });
      });
    };

    $scope.rejectSuggestion = function (suggestion) {
      var note = prompt('Red nedeni (opsiyonel):');

      Allocation.rejectSuggestion({ id: suggestion.id, note: note }).success(function (data) {
        Messenger().post('Öneri reddedildi');
        $scope.loadSuggestions();
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Öneri reddedilemedi',
          type: 'error'
        });
      });
    };

    $scope.selectAllSuggestions = false;
    $scope.toggleAllSuggestions = function () {
      $scope.selectAllSuggestions = !$scope.selectAllSuggestions;
      var filteredSuggestions = $scope.getFilteredSuggestions();
      if ($scope.selectAllSuggestions) {
        $scope.selectedSuggestions = filteredSuggestions.map(function (s) { return s.id; });
      } else {
        $scope.selectedSuggestions = [];
      }
      $scope.$applyAsync();
    };

    $scope.toggleSuggestionSelection = function (suggestionId) {
      var idx = $scope.selectedSuggestions.indexOf(suggestionId);
      if (idx > -1) {
        $scope.selectedSuggestions.splice(idx, 1);
      } else {
        $scope.selectedSuggestions.push(suggestionId);
      }
      // Tümünü seç checkbox'ını güncelle
      var filteredSuggestions = $scope.getFilteredSuggestions();
      $scope.selectAllSuggestions = $scope.selectedSuggestions.length === filteredSuggestions.length;
    };

    $scope.batchApplySuggestions = function () {
      if ($scope.selectedSuggestions.length === 0) {
        Messenger().post({ message: 'Lütfen öneri seçin', type: 'error' });
        return;
      }

      if (!confirm($scope.selectedSuggestions.length + ' öneriyi uygulamak istediğinize emin misiniz?')) return;

      Allocation.batchProcessSuggestions({
        allocation_id: $scope.allocation.id,
        action: 'apply',
        suggestion_ids: $scope.selectedSuggestions
      }).success(function (data) {
        Messenger().post(data.success + ' öneri uygulandı');
        $scope.loadSuggestions();
        $scope.openDetail($scope.allocation);
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Öneriler uygulanamadı',
          type: 'error'
        });
      });
    };

    $scope.batchRejectSuggestions = function () {
      if ($scope.selectedSuggestions.length === 0) {
        Messenger().post({ message: 'Lütfen öneri seçin', type: 'error' });
        return;
      }

      if (!confirm($scope.selectedSuggestions.length + ' öneriyi reddetmek istediğinize emin misiniz?')) return;

      Allocation.batchProcessSuggestions({
        allocation_id: $scope.allocation.id,
        action: 'reject',
        suggestion_ids: $scope.selectedSuggestions
      }).success(function (data) {
        Messenger().post(data.success + ' öneri reddedildi');
        $scope.loadSuggestions();
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Öneriler reddedilemedi',
          type: 'error'
        });
      });
    };

    $scope.exportingSuggestions = false;
    $scope.exportSuggestions = function () {
      $scope.exportingSuggestions = true;
      Allocation.exportSuggestions($scope.allocation.id).success(function (data) {
        // Excel dosyasını indir
        var link = document.createElement('a');
        link.href = data.file;
        link.download = data.filename;
        link.click();
        Messenger().post({ message: 'Excel dosyası hazırlandı', type: 'success' });
        $scope.exportingSuggestions = false;
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Excel oluşturulamadı',
          type: 'error'
        });
        $scope.exportingSuggestions = false;
      });
    };

    $scope.exportingAllocation = false;
    $scope.exportCurrentAllocation = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;
      $scope.exportingAllocation = true;
      Allocation.exportAllocation($scope.allocation.id).success(function (data) {
        var link = document.createElement('a');
        link.href = data.file;
        link.download = data.filename;
        link.click();
        Messenger().post({ message: 'Allokasyon Excel dosyası hazırlandı', type: 'success' });
        $scope.exportingAllocation = false;
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Excel oluşturulamadı',
          type: 'error'
        });
        $scope.exportingAllocation = false;
      });
    };

    $scope.getSuggestionActionClass = function (action) {
      return {
        'remove': 'danger',
        'replace': 'warning',
        'warning': 'info'
      }[action] || 'default';
    };

    $scope.getSuggestionActionLabel = function (action) {
      return {
        'remove': 'Kaldır',
        'replace': 'Değiştir',
        'warning': 'Uyarı'
      }[action] || action;
    };

    $scope.getRuleTypeLabel = function (ruleType) {
      return {
        'on_time': 'Zamanında Teslimat',
        'open_delayed': 'Açık/Geciken',
        'lost_rate': 'Kayıp Oranı',
        'return_rate': 'İade Oranı',
        'customer_blacklist': 'Müşteri Talebi',
        'price': 'Fiyat Optimizasyonu'
      }[ruleType] || ruleType;
    };

    // Toplam tasarruf hesapla (tüm pending öneriler)
    $scope.getTotalSavings = function () {
      if (!$scope.suggestions) return 0;
      return $scope.suggestions
        .filter(function (s) { return s.status === 'pending'; })
        .reduce(function (sum, s) { return sum + (s.savings_amount || 0); }, 0);
    };

    // Seçili önerilerin toplam tasarrufunu hesapla
    $scope.getTotalSelectedSavings = function () {
      if (!$scope.suggestions || !$scope.selectedSuggestions) return 0;
      return $scope.suggestions
        .filter(function (s) { return $scope.selectedSuggestions.indexOf(s.id) > -1; })
        .reduce(function (sum, s) { return sum + (s.savings_amount || 0); }, 0);
    };

    // Seçili önerilerin ortalama birim fiyat farkını hesapla
    $scope.getSelectedAvgPriceDiff = function () {
      if (!$scope.suggestions || !$scope.selectedSuggestions || $scope.selectedSuggestions.length === 0) return 0;
      var selected = $scope.suggestions.filter(function (s) {
        return $scope.selectedSuggestions.indexOf(s.id) > -1 && s.current_price > 0 && s.suggested_price > 0 && s.suggested_price < s.current_price;
      });
      if (selected.length === 0) return 0;
      var totalDiff = selected.reduce(function (sum, s) { return sum + (s.current_price - s.suggested_price); }, 0);
      return totalDiff / selected.length;
    };

    // ============ RULES ============

    // Default kural konfigürasyonu
    $scope.defaultRulesConfig = {
      on_time: { threshold: 85, condition_type: 'below', min_shipments: 30, is_active: true },
      open_delayed: { threshold: 5, condition_type: 'above', min_shipments: 30, is_active: true },
      lost_rate: { threshold: 25, condition_type: 'above', min_shipments: 30, is_active: true },
      return_rate: { threshold: 50, condition_type: 'above', min_shipments: 30, is_active: true }
    };

    $scope.rulesConfig = angular.copy($scope.defaultRulesConfig);
    $scope.rulesMap = {};
    $scope.savingRules = false;

    $scope.loadRules = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      Allocation.getRules($scope.allocation.id).success(function (data) {
        $scope.rules = data.rules;
        $scope.rulesMap = {};

        // Default config'i yükle
        $scope.rulesConfig = angular.copy($scope.defaultRulesConfig);

        // DB'den gelen kuralları üzerine yaz
        angular.forEach(data.rules, function (rule) {
          $scope.rulesMap[rule.rule_type] = rule;
          if ($scope.rulesConfig[rule.rule_type]) {
            $scope.rulesConfig[rule.rule_type].threshold = parseFloat(rule.threshold);
            $scope.rulesConfig[rule.rule_type].condition_type = rule.condition_type;
            $scope.rulesConfig[rule.rule_type].min_shipments = parseInt(rule.min_shipments);
            $scope.rulesConfig[rule.rule_type].is_active = rule.is_active;
          }
        });
      });
    };

    // Kural label'ları
    var ruleNameMap = {
      'on_time': 'Zamanında Teslimat',
      'open_delayed': 'Açık/Geciken',
      'lost_rate': 'Kayıp Oranı',
      'return_rate': 'İade Oranı'
    };

    $scope.saveRule = function (ruleType) {
      var config = $scope.rulesConfig[ruleType];
      if (!config) return;

      var data = {
        allocation_id: $scope.allocation.id,
        rule_type: ruleType,
        name: ruleNameMap[ruleType] || ruleType,
        threshold: config.threshold,
        condition_type: config.condition_type,
        min_shipments: config.min_shipments,
        is_active: config.is_active
      };

      Allocation.saveRule(data).success(function (data) {
        Messenger().post(ruleNameMap[ruleType] + ' kuralı kaydedildi');
        $scope.loadRules();
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Kural kaydedilemedi',
          type: 'error'
        });
      });
    };

    $scope.saveAllRules = function () {
      $scope.savingRules = true;
      var ruleTypes = ['on_time', 'open_delayed', 'lost_rate', 'return_rate'];
      var saved = 0;
      var total = ruleTypes.length;

      angular.forEach(ruleTypes, function (ruleType) {
        var config = $scope.rulesConfig[ruleType];
        var data = {
          allocation_id: $scope.allocation.id,
          rule_type: ruleType,
          name: ruleNameMap[ruleType] || ruleType,
          threshold: config.threshold,
          condition_type: config.condition_type,
          min_shipments: config.min_shipments,
          is_active: config.is_active
        };

        Allocation.saveRule(data).success(function () {
          saved++;
          if (saved === total) {
            $scope.savingRules = false;
            Messenger().post('Tüm kurallar kaydedildi');
            $scope.loadRules();
          }
        }).error(function (response) {
          saved++;
          if (saved === total) {
            $scope.savingRules = false;
          }
          Messenger().post({
            message: ruleNameMap[ruleType] + ' kaydedilemedi: ' + (response.message || 'Hata'),
            type: 'error'
          });
        });
      });
    };

    // ============ BLACKLIST ============
    $scope.cities = [];
    $scope.citiesDistricts = [];
    $scope.weightRanges = [];

    $scope.loadCitiesDistricts = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      Allocation.getCitiesDistricts($scope.allocation.id).success(function (data) {
        $scope.cities = data.cities;
        $scope.citiesDistricts = data.cities_districts;
        $scope.weightRanges = data.weight_ranges || [];
      });
    };

    $scope.loadBlacklist = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      Allocation.getBlacklist($scope.allocation.id).success(function (data) {
        $scope.blacklist = data.blacklist;
      });
    };

    // Seçilen ile göre ilçeleri filtrele
    $scope.getDistrictsForCity = function (city) {
      if (!city) return [];
      return $scope.citiesDistricts
        .filter(function (item) { return item.city === city; })
        .map(function (item) { return item.district; });
    };

    // Desi aralığı formatla (örn: "0-30")
    $scope.formatWeightRange = function (min, max) {
      if (!min && !max) return 'Tümü';
      if (!min) return '0-' + max;
      if (!max) return min + '+';
      return min + '-' + max;
    };

    // Desi aralığı seçildiğinde min/max set et
    $scope.onWeightRangeChange = function () {
      if (!$scope.selectedWeightRangeIdx && $scope.selectedWeightRangeIdx !== 0) {
        $scope.editingBlacklistItem.min_weight = null;
        $scope.editingBlacklistItem.max_weight = null;
        return;
      }
      var range = $scope.weightRanges[$scope.selectedWeightRangeIdx];
      if (range) {
        $scope.editingBlacklistItem.min_weight = range.min_weight;
        $scope.editingBlacklistItem.max_weight = range.max_weight;
      }
    };

    // Inline edit değişkenleri
    $scope.editingBlacklistItem = null;

    $scope.addNewBlacklistItem = function () {
      $scope.selectedWeightRangeIdx = null;
      $scope.editingBlacklistItem = {
        allocation_id: $scope.allocation.id,
        company_name: '',
        city: '',
        district: '',
        min_weight: null,
        max_weight: null,
        reason: '',
        is_active: true,
        isExisting: false
      };
    };

    $scope.editBlacklistItem = function (item) {
      $scope.editingBlacklistItem = angular.copy(item);
      $scope.editingBlacklistItem.isExisting = true;

      // Desi aralığı index'ini bul
      $scope.selectedWeightRangeIdx = null;
      if (item.min_weight !== null && item.max_weight !== null) {
        for (var i = 0; i < $scope.weightRanges.length; i++) {
          if ($scope.weightRanges[i].min_weight == item.min_weight && $scope.weightRanges[i].max_weight == item.max_weight) {
            $scope.selectedWeightRangeIdx = '' + i;
            break;
          }
        }
      }
    };

    $scope.cancelBlacklistEdit = function () {
      $scope.editingBlacklistItem = null;
    };

    $scope.saveBlacklistItem = function () {
      if (!$scope.editingBlacklistItem.company_name) {
        Messenger().post({ message: 'Kargo firması seçiniz', type: 'error' });
        return;
      }

      var data = {
        allocation_id: $scope.allocation.id,
        company_name: $scope.editingBlacklistItem.company_name,
        city: $scope.editingBlacklistItem.city || null,
        district: $scope.editingBlacklistItem.district || null,
        min_weight: $scope.editingBlacklistItem.min_weight || null,
        max_weight: $scope.editingBlacklistItem.max_weight || null,
        reason: $scope.editingBlacklistItem.reason,
        is_active: $scope.editingBlacklistItem.is_active
      };

      Allocation.saveBlacklist(data).success(function () {
        Messenger().post('Blacklist kaydedildi');
        $scope.loadBlacklist();
        $scope.editingBlacklistItem = null;
      }).error(function (errorResponse) {
        Messenger().post({
          message: errorResponse.message || 'Blacklist kaydedilemedi',
          type: 'error'
        });
      });
    };

    $scope.deleteBlacklistItem = function (item) {
      if (!confirm('Bu kaydı silmek istediğinize emin misiniz?')) return;

      Allocation.deleteBlacklist(item.id).success(function (data) {
        Messenger().post('Kayıt silindi');
        $scope.loadBlacklist();
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Kayıt silinemedi',
          type: 'error'
        });
      });
    };

    // Modal'la uyumluluk için eski metodları (artık kullanılmıyor)
    $scope.openBlacklistModal = function () {
      $scope.addNewBlacklistItem();
    };

    $scope.editBlacklist = function (item) {
      $scope.editBlacklistItem(item);
    };

    $scope.saveBlacklist = function () {
      $scope.saveBlacklistItem();
    };

    $scope.deleteBlacklist = function (item) {
      $scope.deleteBlacklistItem(item);
    };

    $scope.cargoCompanies = [
      'BOVO', 'HEPSIJET', 'SENDEO', 'MNG', 'PTT', 'YURTICI',
      'BOLT', 'BOVOBOLT', 'ARAS', 'UPS', 'FEDEX', 'DPD', 'GLS', 'WIDECT',
      'KARGOMSENDE', 'KOLAYGELSIN', 'SURAT', 'SURATKARGO',
      'GKN', 'SCOTTY', 'YANGO', 'KARGOIST', 'MARS', 'CARGOX'
    ];

    // ============ ALLOCATION ROWS MANAGEMENT ============

    // Grid'de yapılan değişiklikleri kaydet
    $scope.saveAllocationRows = function () {
      if (!$scope.allocation || !$scope.allocation.id) return;

      Allocation.saveRows($scope.allocation.id, $scope.allocation.rows).success(function (data) {
        Messenger().post({ message: 'Değişiklikler kaydedildi', type: 'success' });
        $scope.openDetail($scope.allocation); // Reload
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Kayıt başarısız',
          type: 'error'
        });
      });
    };

    // Tek satırı sil
    $scope.deleteAllocationRow = function (rowId) {
      if (!confirm('Bu satırı silmek istediğinize emin misiniz?')) return;

      Allocation.deleteRow($scope.allocation.id, rowId).success(function (data) {
        Messenger().post({ message: 'Satır silindi', type: 'success' });
        $scope.openDetail($scope.allocation); // Reload
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Silme başarısız',
          type: 'error'
        });
      });
    };

    // Seçili satırları sil (grid selection)
    $scope.deleteSelectedRows = function () {
      var selectedRows = $scope.gridApi.selection.getSelectedRows();
      if (selectedRows.length === 0) {
        Messenger().post({ message: 'Lütfen satır seçin', type: 'error' });
        return;
      }

      if (!confirm(selectedRows.length + ' satırı silmek istediğinize emin misiniz?')) return;

      var rowIds = selectedRows.map(function (r) { return r.id; });
      Allocation.deleteRows($scope.allocation.id, rowIds).success(function (data) {
        Messenger().post({ message: data.message || 'Satırlar silindi', type: 'success' });
        $scope.openDetail($scope.allocation); // Reload
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Silme başarısız',
          type: 'error'
        });
      });
    };

  }
]);